import { AssetCustomField, AssetInstance } from '../../constants/Types';
import { AssetFilterSelection } from './components/AssetFilterModal/components/AssetFilterItem';

export const isPlacedOnMap = (asset: AssetInstance) => {
  let hasXY: boolean = false;
  const coordFields: string[] = ['geox', 'geoy'];
  asset.customFields.forEach((field: AssetCustomField) => {
    if (!hasXY && coordFields.includes(field.name.trim().toLowerCase())) {
      hasXY = true;
    }
  });
  return hasXY;
};

export const assetLocationName = (asset: AssetInstance) => {
  let locationName: string = asset.locationFloor;
  if (asset.locationArea) locationName += `, ${asset.locationArea}`;
  if (asset.locationSpace) locationName += `, ${asset.locationSpace}`;
  return locationName;
};

export const checkIfFiltersApplied = (filters: AssetFilterSelection[]): boolean => filters
  .filter((filter: AssetFilterSelection) => !!filter.value).length > 0;
